var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "23px",
    viewBox: "0 0 18 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets_Export",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,2.25 L9,2.25 L7.875,2.25 L2.25,2.25 L2.25,0 L0,0 L0,2.25 L0,13.5 L0,22.5 L2.25,22.5 L2.25,13.5 L6.75,13.5 L7.875,13.5 L18,13.5 L15.75,7.875 L18,2.25 Z M13.6575,8.7075 L14.67,11.25 L7.875,11.25 L6.75,11.25 L2.25,11.25 L2.25,4.5 L7.875,4.5 L9,4.5 L14.68125,4.5 L13.66875,7.0425 L13.33125,7.875 L13.6575,8.7075 Z M10.125,7.875 C10.125,9.1125 9.1125,10.125 7.875,10.125 C6.6375,10.125 5.625,9.1125 5.625,7.875 C5.625,6.6375 6.6375,5.625 7.875,5.625 C9.1125,5.625 10.125,6.6375 10.125,7.875 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.dba57e2f9bf98ca80441831e2a2d5c3c.svg";
export { ForwardRef as ReactComponent };